import React from 'react';
import Head from "next/head";
import Router, { useRouter } from "next/router";
import NProgress from "nprogress";
import { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { useSelector, useDispatch } from "react-redux";
import ReactGA from "react-ga";
import NavBar from "../components/NavBar";
import Footer from "./Footer";
import sanitize from '../helpers/sanitize';
// import Loader from "./UI/loader";
import axiosInstance from "../config/axios";
import { closingHourFn } from "../helpers/closingTime";
import { deliveryClosingHourFn } from '../helpers/deliveryClosingTime';
import CookiePolicyModal from "../components/CookiePolicyModal";
import { disclaimerShow } from "../store/actions/acceptPolicy";

const navItems = [
  { icon: "/images/home-icon.svg", label: "Home", route: "/" },
  { icon: "/images/envelope-icon.svg", label: "Wallet", route: "/wallet" },
  { icon: "/images/orders-icon.svg", label: "Orders", route: "/orders" },
  { icon: "/images/gift-icon.svg", label: "Giftcard", route: "/giftcard" },
  { icon: "/images/user-icon.svg", label: "You", route: "/profile" },
];

Router.onRouteChangeStart = () => {
  // console.log(url);
  NProgress.start();
};

Router.onRouteChangeComplete = () => NProgress.done();

Router.onRouteChangeError = () => NProgress.done();

const trackingId = "UA-92515574-1";


ReactGA.initialize(trackingId);

const Layout = ({ children, showSecFooter }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [disclaimerText, setDisclaimerText] = useState("")
  const [showCookieModal, setShowCookieModal] = useState(false);
 

  const btnRef = useRef();
  // const electionBtnRef = useRef();

  useEffect(() => {
    ReactGA.initialize(trackingId, { useExistingGa: true });
    ga("create", trackingId, "auto", { cookieFlags: "SameSite=None; Secure" });
  }, []);

  const [orderingTime, setOrderingTime] = useState("");
  const [deliveryOrderingTime, setDeliveryOrderingTime] = useState("")
  const [timeOne, setTimeOne] = useState("");
  const [timeTwo, setTimeTwo] = useState("");
  const [deliveryTimeOne, setDeliveryTimeOne] = useState("")
  const [deliveryTimeTwo, setDeliveryTimeTwo] = useState("")
  const [psaContent, setPsaContent] = useState(null);
  const [deliveryType, setDeliveryType] = useState(null)

  const acceptCookies = useSelector(
    (state) => state.acceptPolicy.acceptedPolicy
  );
  const showDisclaimer = useSelector(
    (state) => state.acceptPolicy.seenDisclaimer
  );

  useEffect(() => {
  if (acceptCookies) return;

  const handleScroll = () => {
    setShowCookieModal(true);

    // only fire once
    window.removeEventListener("scroll", handleScroll);
  };

  window.addEventListener("scroll", handleScroll, {
    passive: true,
  });

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, [acceptCookies]);
 
  // useEffect(() => {
  //    if (typeof $ !== "undefined"){
  //     $("#storeClosed").on("click", function (e) {
  //     if ($(e.target).is("#storeClosed")) {
        
  //     }
  //   });
  //    }
    
  // }, []);

  useEffect(() => {
  if (showDisclaimer) return;

  const handleInteraction = () => {
    btnRef.current?.click();

    // Remove all listeners after the first interaction
    events.forEach((event) =>
      window.removeEventListener(event, handleInteraction)
    );
  };

  const events = ["scroll", "click", "touchstart", "keydown"];

  events.forEach((event) =>
    window.addEventListener(event, handleInteraction, {
      passive: true,
    })
  );

  return () => {
    events.forEach((event) =>
      window.removeEventListener(event, handleInteraction)
    );
  };
}, [showDisclaimer]);
  useEffect(() => {
    const storedDeliveryType = localStorage.getItem("Deliverytype");
        const storeDelivery = JSON.parse(storedDeliveryType);
   
    console.log("order type",  storeDelivery);
    setDeliveryType( storeDelivery);
  }, []);

  useEffect(() => {
  const fetchSettings = async () => {
    try {
      const {
        data: { data },
      } = await axiosInstance.get("settings");

      setDisclaimerText(data.disclaimer);
      setPsaContent(data.psa_announcement);

      localStorage.setItem(
        "giftcard-max-amount",
        data.maximum_giftcard_purchase
      );

      localStorage.setItem(
        "giftcard-min-amount",
        data.minimum_giftcard_purchase
      );

      localStorage.setItem(
        "available-payment-gateway",
        JSON.stringify(data.allowed_payment_gateways)
      );

      const convertTo12Hour = (time) => {
        const [hour, minute] = time.split(":");
        const h = parseInt(hour, 10);
        const ampm = h >= 12 ? "PM" : "AM";
        const formattedHour = h % 12 || 12;

        return `${formattedHour}:${minute}${ampm}`;
      };

      setDeliveryTimeOne(
        convertTo12Hour(data.delivery_opening_time)
      );

      setDeliveryTimeTwo(
        convertTo12Hour(data.delivery_closing_time)
      );

      setDeliveryOrderingTime(
        deliveryClosingHourFn(data)
      );
    } catch (error) {
      console.error(error);
    }
  };

  const fetchOrderingTime = async () => {
    try {
      const {
        data: { data },
      } = await axiosInstance.get("settings/get-order-times");

      const convertTo12Hour = (time) => {
        const [hour, minute] = time.split(":");
        const h = parseInt(hour, 10);
        const ampm = h >= 12 ? "PM" : "AM";
        const formattedHour = h % 12 || 12;

        return `${formattedHour}:${minute}${ampm}`;
      };

      setTimeOne(convertTo12Hour(data.opening_time));
      setTimeTwo(convertTo12Hour(data.closing_time));
      setOrderingTime(closingHourFn(data));
    } catch (error) {
      console.error(error);
    }
  };

  const loadAfterInitialRender = () => {
    fetchSettings();
    fetchOrderingTime();
  };

  if ("requestIdleCallback" in window) {
    const idleId = window.requestIdleCallback(loadAfterInitialRender);

    return () => {
      window.cancelIdleCallback(idleId);
    };
  }

  const timeoutId = setTimeout(loadAfterInitialRender, 1000);

  return () => clearTimeout(timeoutId);
}, []);
 

  // useEffect(() => {
   
  //   const fetchDisclaimer = async () => {
  //     try {
  //       const {
  //         data: { data },
  //       } = await axiosInstance.get(`settings`);
  //       setDisclaimerText(data.disclaimer)
  //       const psaContent = data.psa_announcement;
  //       setPsaContent(psaContent)
  //       const giftCardMaximumAmount = data.maximum_giftcard_purchase;
  //       const giftCardMinimumAmount = data.minimum_giftcard_purchase;
  //       const availablePaymentGateway = data.
  //       allowed_payment_gateways;

  //       localStorage.setItem("giftcard-max-amount", giftCardMaximumAmount)
  //       localStorage.setItem("giftcard-min-amount",giftCardMinimumAmount)
  //       localStorage.setItem(
  //         "available-payment-gateway",
  //         JSON.stringify(availablePaymentGateway)
  //       );
  //       const convertTo12Hour = (time) => {
  //         const [hour, minute] = time.split(":");
  //         const h = parseInt(hour, 10);
  //         const ampm = h >= 12 ? "PM" : "AM";
  //         const formattedHour = h % 12 || 12; // converts "00" → "12"
  //         return `${formattedHour}:${minute}${ampm}`;
  //       };
  //      const newDeliveryFirstTime = convertTo12Hour(data.delivery_opening_time);
  //       const newDeliverySecondTime = convertTo12Hour(data.delivery_closing_time);
  //         setDeliveryTimeOne(newDeliveryFirstTime)
  //       setDeliveryTimeTwo(newDeliverySecondTime)
  //       const deliveryOrderTimeState = deliveryClosingHourFn (data)
  //       setDeliveryOrderingTime(deliveryOrderTimeState)
       
  //     } catch (error) {
  //       // console.log(error);
  //     }
  //   };
  //   fetchDisclaimer();
  // }, []);
 

  // useEffect(() => {
  //   const fetchOrderingTime = async () => {
  //     try {
  //       const {
  //         data: { data },
  //       } = await axiosInstance.get(`settings/get-order-times`);
  
  //       // Convert 24-hour to 12-hour format
  //       const convertTo12Hour = (time) => {
  //         const [hour, minute] = time.split(":");
  //         const h = parseInt(hour, 10);
  //         const ampm = h >= 12 ? "PM" : "AM";
  //         const formattedHour = h % 12 || 12; // converts "00" → "12"
  //         return `${formattedHour}:${minute}${ampm}`;
  //       };
  
  //       const newFirstTime = convertTo12Hour(data.opening_time);
  //       const newSecondTime = convertTo12Hour(data.closing_time);
        
  
  //       setTimeOne(newFirstTime);
  //       setTimeTwo(newSecondTime);
      
       
  
  //       const orderTimeState = closingHourFn(data);
  //       setOrderingTime(orderTimeState);
  //     } catch (error) {
  //       console.error("Error fetching order times:", error);
  //     }
  //   };
  
  //   fetchOrderingTime();
  // }, []);
 
  

  // useEffect(() => {
  //   if (typeof $ !== "undefined"){
  //     $("#disclaimer").on("click", function (e) {
  //     if ($(e.target).is("#disclaimer")) {
  //       Cookies.set("show-disclaimer", "true");
  //       dispatch(disclaimerShow(true));
  //     }
  //   });

  //   }
    
  // }, []);

  const seenTheDisclaimerHandler = (e) => {
     if (typeof $ !== "undefined"){
      e.preventDefault();
    Cookies.set("show-disclaimer", "true");
    dispatch(disclaimerShow(true));
    $("#disclaimer").modal("hide");

     }
    
  };

  const closeElectionModalHandler = (e) => {
     if (typeof $ !== "undefined"){
       e.preventDefault();
    $("#electionModal").modal("hide");

     }
   
  };

  const gotoHome = (e) => {
    if (typeof $ !== "undefined"){
       e.preventDefault();
    Router.push("/");
    $("#storeClosed").modal("hide");

    }
   
  };
  const closeModal = (e) => {
    if (typeof $ !== "undefined"){
      e.preventDefault();
    //Router.push("/");
    $("#storeClosed").modal("hide");
    }
    
  };
  // useEffect(() => {
  //   const content = localStorage.getItem("psaContent");
  //   console.log("psa content", content);
  //   setPsaContent(content);
  // }, [psaContent]);
useEffect(() => {
  let lastScrollY = window.scrollY;

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    const nav = document.querySelector(".mobile-nav-tab");
    if (!nav) return;

    if (currentScrollY < lastScrollY) {
      // scrolling up — show nav
      nav.style.transform = "translateY(0)";
    } else {
      // scrolling down — hide nav
      nav.style.transform = "translateY(100%)";
    }
    lastScrollY = currentScrollY;
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="keyword" content="MEALS FOOD RESTAURANT NIGERIA" />
      </Head>
      <section className="psa-section">
  <div className="psa-background">
    {psaContent && (
      <h6 className="text-center psa-text m-0">
        {psaContent}
      </h6>
    )}
  </div>
</section>
      <NavBar orderingTime={orderingTime}  deliveryOrderingTime={deliveryOrderingTime}/>
     
     
     

      {children}


      <section className="restaurant-display">
        <div className="container">
          <div className="row">
            <div className="col-md-9 mx-auto">
              {/* <div className="modal fade" id="storeClosed" role="dialog">
                <div className="modal-dialog closed-dialog">
                  
                  <div className="modal-content">
                    <div className="modal-header">
                      <button
                        onClick={closeModal}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                      >
                        &times;
                      </button>
                      <button
        id="storeClosedClose"
        data-dismiss="modal"
        style={{ display: "none" }}
      />
                      <h4 className="modal-title">Store closed</h4>
                    </div>
                    <div className="modal-body">
                      <div className="restaurants closed-res">
                      {
                        deliveryType === "delivery" ? (
                          <p>
                          We're currently closed for delivery, You can place your orders between {deliveryTimeOne} and {deliveryTimeTwo} tomorrow.🕒 Switch to pickup now or order for later.  Thanks for your understanding!
                        </p>) : ( <p>
                          We're currently closed for pickup, You can place your orders between {timeOne} and {timeTwo} tomorrow🕒or order for later. Thanks for your understanding!
                        </p>)
                      }
                        
                       
                        {router.pathname != "/" && (
                          <button
                            onClick={gotoHome}
                            className="btn btn-order mx-auto mt-3"
                          >
                            <span className="text">Return to homepage</span>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {!showDisclaimer && (
        <section className="restaurant-display">
          <div className="container">
            <div className="row">
              <div className="col-md-9 mx-auto">
                <div className="modal fade" id="disclaimer" role="dialog">
                  <div className="modal-dialog notification-dialog modal-dialog-centered">
                   
                    <div className="modal-content">
                    <div className="modal-header d-flex justify-content-center position-relative">
  <button
    onClick={seenTheDisclaimerHandler}
    type="button"
    className="close position-absolute"
    style={{ right: '15px' }}
    data-dismiss="modal"
    aria-label="Close"
  >
    <span aria-hidden="true">&times;</span>
  </button>
  <h4 className="modal-title text-center">Disclaimer!</h4>
</div>

                      <div className="modal-body pt-0">
                        <div className="restaurants closed-res">
                         
                          <div
                          style={{ minHeight: '80px' }} 
        dangerouslySetInnerHTML={{ __html: sanitize(disclaimerText)}}
      />
                         <div className="text-center">
  <h6>Download the Kilimeals App</h6>
  <div className="d-flex justify-content-center gap-5">
    <a
      href="https://play.google.com/store/apps/details?id=com.kilimanjaro.kilimeals"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="/images/playstore.png"
        alt="play store icon"
            width={172}
                    height={50}
                    style={{ display: 'block', height: '50px', width: 'auto' }}
      />
    </a>
    <a
      href="https://apps.apple.com/us/app/kilimeals/id1571917847"
      target="_blank"
      rel="noopener noreferrer"
      className="ml-2"
    >
      <img
        src="/images/appstore-barge-new.png"
        alt="app store icon"
        width={167}
                    height={50}
                    style={{ display: 'block', height: '50px', width: 'auto' }}
      />
    </a>
  </div>
</div>

<div className="mt-3 d-flex justify-content-center gap-4" >
  <div style={{fontSize:"20px"}}>
    <span>
      <i className="fa fa-phone" aria-hidden="true"></i>
    </span>
    <a className="link-red" href="tel:070054543663">
      {" "}0700 5454 3663{" "}
    </a>
  </div>
  <div className="ml-4" style={{fontSize:"20px"}}>
    <span>
      <i className="fa fa-whatsapp" aria-hidden="true"></i>
    </span>
    <a className="link-red" href="tel:08100393579">
      {" "}0810 039 3579
    </a>
  </div>
</div>

                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      

      <button
        ref={btnRef}
        type="button"
        id="MybtnPreventHTML"
        className="btn btn-primary d-none"
        data-target="#disclaimer"
        data-toggle="modal"
      >
        Open Modal
      </button>

      {!acceptCookies && showCookieModal && <CookiePolicyModal />}
      
     
      <Footer showSecFooter={showSecFooter} />
       <section className='d-block d-md-none'>
  

 
  <div className="mobile-nav-tab ">
    <div className="mobile-nav-tab__items ">
      {navItems.map((item) => {
        const isActive = router.pathname === item.route;
        return (
          <button
            key={item.label}
            className={`mobile-nav-tab__item ${isActive ? "mobile-nav-tab__item--active" : ""}`}
            onClick={() => Router.push(item.route)}
          >
            <img src={item.icon} alt={item.label} className="mobile-nav-tab__icon" />
            <span className="mobile-nav-tab__label">{item.label}</span>
          </button>
        );
      })}
    </div>
   
  </div>
 
</section>

      
    </>
  );
};

export default Layout;
